import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as LaunchDarkly from 'launchdarkly-react-client-sdk';
import * as SingleSPA from 'single-spa';
import * as history from 'history';
import * as LottieWeb from 'lottie-web';
import * as Polished from 'polished';
import * as Luxon from 'luxon';
import * as GoogleLibPhoneNumber from 'google-libphonenumber';
import * as Graphql from 'graphql';

import { ObjectOrArray } from '@chocoapp/toolbelt-utils';
import insertNewImportMap, { ImportMapType } from '../utils/insertNewImportMap';

window.SystemJS = window.System;

export const commonDeps: ObjectOrArray<any> = {
  react: React,
  'react-dom': ReactDOM,
  'launchdarkly-react-client-sdk': LaunchDarkly,
  'single-spa': SingleSPA,
  history,
  'lottie-web': LottieWeb,
  polished: Polished,
  luxon: Luxon,
  'google-libphonenumber': GoogleLibPhoneNumber,
  graphql: Graphql,
};

const getDependenceConfigs = () => {
  const aliasPrefix = 'commonDependencies';
  return Object.entries(commonDeps).map(([name, importedPackage]) => ({
    name,
    importedPackage,
    alias: `${aliasPrefix}:${name}`,
  }));
};

export const commonDepsConfigs = getDependenceConfigs();

const registerDepsAndGetImportMap = () => {
  const imports: ImportMapType['imports'] = {};
  commonDepsConfigs.forEach(({ alias, importedPackage, name }) => {
    window.SystemJS.set(alias, importedPackage);
    imports[name] = alias;
  });

  return { imports };
};

export function startCommonDeps() {
  const dependencies = registerDepsAndGetImportMap();

  insertNewImportMap(dependencies);
}

startCommonDeps();
